import { Default, getDefault } from '@master/annotation/Default'
import { TypeBase } from '@master/model/TypeBase'

export class Assumptions extends TypeBase {
  // Default value should be String
  // fixed from ticket : https://phabricator.wen-pl.com/T3137
  // this is because in KeyValueMapApiBuilder, the map is in <string, string> format, should should pass the value as string to FA-Portal
  // when pass with integer value, hint exception: 'java.lang.Integer cannot be cast to java.lang.String'
  @Default('3')
  annualinflation = undefined

  @Default('5')
  annualinvestmentreturn = undefined

  @Default('3')
  annualsalaryincrement = undefined

  @Default('4')
  increaseineducationcosts = undefined

  @Default('65')
  retirementincome = undefined

  @Default('60')
  bscSpecifiedIncomeVariable = undefined

  constructor () {
    super('assumptions')
  }

  convertToRawData () {
    Object.keys(this).forEach(key => {
      if (this[key]) {
        this[key] = this[key].toString()
      }
    })
    return super.convertToRawData()
  }

  getAllRawKeys () {
    return Object.keys(this).map(key => this.snakeCaseKey(key))
  }

  loadDefault () {
    Object.keys(this).forEach((key) => {
      this[key] = getDefault(this, key) || this[key]
    })
  }
}
